<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="epig"> </p>
<p class="FMEP">The difference in mind between man and the higher animals, great as it is, certainly is one of degree and not of kind.</p>
<p class="FMEPC"><span class="ePub-SC-B">—CHARLES DARWIN</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?8d3320fa